import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import "./styles.css";
import emailjs from "@emailjs/browser";
// import {registerMail} from './mail'
function Contact() {
  const form = useRef();
  // const navigate = useNavigate();
  const [inputs, setInput] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const { name, email, subject, message } = inputs;

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInput((inputs) => ({
      ...inputs,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(inputs);
    e.preventDefault();
    const data = {
      Name: name,
      Email: email,
      Subject: subject,
      Message: message,
    };
    axios
      .post(
        "https://sheet.best/api/sheets/87991b44-8409-449e-ade9-a97f9c015efe",
        data
      )
      .then((response) => {
        console.log(response);

        // setInput({});
      });

    Swal.fire({
      position: "top-center",
      icon: "success",
      title: "Good job!",
      text: "Thanks for connecting with me!",
      showConfirmButton: false,
      timer: 5000,
    });
setInput({
  name: "",
  email: "",
  subject: "",
  message: "",
});
    emailjs
      .sendForm(
        "service_4rbu4u7",
        "template_h70gq4w",
        form.current,
        "3gYp-CZk63yFugvvj"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );

    // registerMail(inputs)
  };
  return (
    <section id="contact" class="contact px-5">
      <div class="container px-5">
        <div class="section-title">
          <h2>Contact Me</h2>
          <p>
            I appreciate your interest in Profile. Please fill up the form below
            and I will get back to you in the next 24 hours.
          </p>
        </div>

        <div class="align-items-center">
          <form
            ref={form}
            role="form"
            class="php-email-form"
            onSubmit={handleSubmit}
          >
            <div class="row">
              <div class="form-group col-md-6">
                <label for="name">Your Name</label>
                <input
                  type="text"
                  name="name"
                  value={name}
                  class="form-control"
                  id="name"
                  onChange={handleChange}
                  required
                />
              </div>
              <div class="form-group col-md-6">
                <label for="name">Your Email</label>
                <input
                  type="email"
                  class="form-control"
                  name="email"
                  value={email}
                  onChange={handleChange}
                  id="email"
                  required
                />
              </div>
            </div>
            <div class="form-group">
              <label for="name">Subject</label>
              <input
                type="text"
                class="form-control"
                name="subject"
                value={subject}
                onChange={handleChange}
                id="subject"
              />
            </div>
            <div class="form-group">
              <label for="name">Message</label>
              <textarea
                class="form-control"
                name="message"
                rows="10"
                value={message}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <div class="text-center">
              <button type="submit">Send Message</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact;
